import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function n(r, e) {
  return o(), l("svg", c, [...e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 2c-2.24 0-4.4.88-5.99 2.47A8.57 8.57 0 0 0 2 10.5c0 1.68.49 3.3 1.41 4.69l-.86 2.57a.7.7 0 0 0 .16.7c.18.2.46.26.7.18l2.7-.86a8.46 8.46 0 0 0 11.66-2.9A8.6 8.6 0 0 0 19 10.5a8.57 8.57 0 0 0-2.5-6.02 8.45 8.45 0 0 0-6-2.48m0 1.4v-.7za7.04 7.04 0 0 1 5.02 2.07 7.17 7.17 0 0 1 2.1 5.03 7.21 7.21 0 0 1-3.77 6.26 7.08 7.08 0 0 1-7.27-.33.69.69 0 0 0-.59-.08l-1.7.54.54-1.6a.7.7 0 0 0-.1-.63 7.03 7.03 0 0 1-1.35-4.16 7.2 7.2 0 0 1 2.1-5.04A7.07 7.07 0 0 1 10.5 3.4m4.27 9.26a37 37 0 0 0-1.59-.9c-.2-.1-.34-.15-.51.06-.17.2-.64.66-.78.8-.14.13-.27.14-.49 0l-.14-.07c-.3-.16-.9-.47-1.57-1.16-.62-.63-1-1.38-1.12-1.61-.11-.23.01-.34.13-.44a3.6 3.6 0 0 0 .63-.7c.08-.14.06-.27 0-.39a46 46 0 0 1-.55-1.68c-.13-.38-.3-.4-.42-.4l-.05-.01-.43-.05a.83.83 0 0 0-.62.23l-.05.04c-.25.23-.8.71-.88 1.72a4.2 4.2 0 0 0 .72 2.33l.04.06c.24.4 1.5 2.5 3.52 3.56.52.27.92.44 1.24.57.52.2 1.01.22 1.4.2.44-.03 1.37-.42 1.6-.91.23-.5.26-.94.21-1.03-.04-.08-.14-.14-.29-.22",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
